import BaseBirthdateDropdown from 'registration/js/base/fields/birthdate_dropdown';

import template from 'registration/templates/dark/fields/birthdate_dropdown.html';

const BirthdateDropdown = BaseBirthdateDropdown.extend({
    template,
});

export default BirthdateDropdown;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/fields/birthdate_dropdown.js